import React from 'react';
import ExpenseRegisterModule from '../purchases/components/ExpenseRegister';

// Finance tracker sidebar "Expense Register" now reuses the full purchases Expense Register module.
const ExpenseRegister = () => {
  return <ExpenseRegisterModule />;
};

export default ExpenseRegister;

